export default __webpack_public_path__ + "static/media/ctn-moszna.e15a16cc.png";